module.exports = __webpack_public_path__ + "img/[礼物].ad549612.svg";